/** @namespace routes */

import { register } from 'tmr/tmr/ngModuleRegistry'

import * as operations from './operations'
import * as encoding from './encoding/encoding'
import * as inbound from './inbound/inbound'
import * as inventory from './inventory/inventory'
import * as inventoryList from './inventory/inventoryList'
import * as inventoryCreate from './inventory/inventoryCreate'
import * as outbound from './outbound/outbound'
import * as phaseToPhase from './phaseToPhase/phaseToPhase'
import * as print from './print/print'
import * as printController from './print/print.controller'
import * as printOrderRows from './print/printOrderRows'
import * as printProductionLots from './print/printProductionLots'
import * as printProducts from './print/printProducts'
import * as printQueue from './print/printQueue'
import * as sessionTransferToZone from './sessionTransferToZone/sessionTransferToZone'
import * as tagInfo from './tagInfo/tagInfo'
import * as transferToZone from './transferToZone/transferToZone'
import * as CycleCount from './cycleCount/cycleCount'
import * as CycleCountList from './cycleCount/cycleCountList'
import * as CycleCountCreate from './cycleCount/cycleCountCreate'

export default register(
  'tmr.core.routes.operations',
  operations,
  encoding,
  inbound,
  inventory,
  inventoryList,
  inventoryCreate,
  outbound,
  phaseToPhase,
  print,
  printController,
  printOrderRows,
  printProductionLots,
  printProducts,
  printQueue,
  sessionTransferToZone,
  tagInfo,
  transferToZone,
  CycleCount,
  CycleCountList,
  CycleCountCreate
)
